import { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

export default function useNavigationBlock() {
  const history = useHistory();
  const unblockRef = useRef(null);
  // The blocker reads this ref, not render state: callers unblock and then
  // history.push in the same tick (after a save), before React re-renders.
  // Reading the state there swallowed the push and left the user on the page.
  const blockedRef = useRef(false);

  const [isNavigationBlocked, setBlockedState] = useState(false);
  const [pendingLocation, setPendingLocation] = useState(null);

  const setIsNavigationBlocked = useCallback((value) => {
    blockedRef.current = value;
    setBlockedState(value);
  }, []);

  useEffect(() => {
    unblockRef.current = history.block((location) => {
      if (blockedRef.current) {
        setPendingLocation(location);
        return false;
      }
      return true;
    });

    return () => {
      if (unblockRef.current) {
        unblockRef.current();
      }
    };
  }, [history]);

  const confirmNavigationChange = () => {
    if (unblockRef.current) {
      unblockRef.current();
    }
    if (pendingLocation) {
      history.push(pendingLocation.pathname);
    }
  };

  const cancelNavigationPopup = () => {
    setPendingLocation(null);
  };

  const isShowNavigationBlockPopup = isNavigationBlocked && pendingLocation;

  return {
    isNavigationBlocked,
    setIsNavigationBlocked,
    isShowNavigationBlockPopup,
    confirmNavigationChange,
    cancelNavigationPopup,
  };
}
